import { GlobalConstantsTexte } from "globales-projekt-angular";

export class ConstantsTexte {
  static readonly ANWENDUNGSNAME: string = 'Literaturdatenbank Tierwohlindikatoren';

  static readonly ALARM_ZU_VIELE_DATENSAETZE: string =
    'Bei mehr als 1500 Datensätze können diese nicht alle auf einmal herunterladen geladen werden. Bitte wählen sie weniger Datensätze.';

  static readonly ALARM_KEINE_DATENSAETZE_AUSGEWAEHLT: string =
    'Keine Datensätze ausgewählt';
  static readonly QUESTION_DATENSAETZE_AUSGEWAEHLT_WIRKLICH_HERUNTERLADEN: string =
    'Es wurden ' +
    GlobalConstantsTexte.TEXT_ERSETZUNG_EINS +
    ' Datensätzen ausgewählt. Es wird erwartet, dass das Zip-File ' +
    GlobalConstantsTexte.TEXT_ERSETZUNG_ZWEI +
    ' mb groß sein wird.\nMöchten sie die Dateien trotzdem herunterladen?';

    static readonly PAGINATOR_JE_SEITE: string = 'Indikatoren ' + GlobalConstantsTexte.PAGINATOR_JE_SEITE;
}
